import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import ProfileApproval from '@zr/jobseeker-public/apps/profile-approval/components/ProfileApproval';

import {
  MERGE_PARSED_RESUME_APPROVAL,
} from '../../../screenTypeSchema';

import { applyDataPropTypes } from '../../../applyFlowPropTypes';

import screenTypeTelemetry from '../screenTypeTelemetry';

import './MergeParsedResumeApproval.less';

export function MergeParsedResumeApproval({
  applyData,
  onScreenTypeFinish,
  setIsLoading,
}) {
  const {
    logFinish,
    logView,
  } = screenTypeTelemetry(MERGE_PARSED_RESUME_APPROVAL, applyData);

  useEffect(() => {
    logView();
  }, [logView]);

  const handleContinue = async () => {
    logFinish({
      interaction: 'continue',
    });
    await onScreenTypeFinish({
      // this ensures we do not get this screen type/action again
      approved_parsed_resume: 1,
    });
  };

  // if this screen is not working, then just move on from it
  const handleFatalError = async () => {
    logFinish({
      interaction: 'error_continue',
    });
    await onScreenTypeFinish({
      // this ensures we do not get this screen type/action again
      approved_parsed_resume: 1,
    });
  };

  // redirect happens in screen type, this is just a telemetry callback for now
  const handleEdit = () => {
    logFinish({
      interaction: 'edit',
    });
  };

  return (
    <div className="MergeParsedResumeApproval">
      <ProfileApproval
        onContinue={handleContinue}
        onEdit={handleEdit}
        onFatalError={handleFatalError}
        setIsLoading={setIsLoading}
      />
    </div>
  );
}

MergeParsedResumeApproval.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  onScreenTypeFinish: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func,
};

MergeParsedResumeApproval.defaultProps = {
  setIsLoading: () => {},
};

export default MergeParsedResumeApproval;
